import {
  TPartSettingsTabKey,
} from '@/page/part/settings.ts';

const tabs: Record<TPartSettingsTabKey, string> = {
  attributes: 'Attribute',
  tableView: 'Übersichtstabelle',
};

export default {
  tabs,
};
